import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../../theme';

export const useAdminConsolePageStyles = createStyles(({ token }) => ({
  innerContent: {
    '&&': {
      justifyContent: 'flex-start',
    },
  },
  heading: {
    padding: `0 ${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM}px`,

    'h2.AdminConsoleTitle': {
      fontFamily: ThemeFont.FONT_CONDENSED,
      gap: 'initial',
      fontWeight: token.fontWeightStrong,
      color: token.colorText,
      fontSize: token.fontSizeHeading2,
    },
  },
}));
